import React from "react";
import InfoCard from "../../../components/ui/InfoCard";
import { formatPhoneNumber } from "../../../utils/helpers";

// A presentational card: it renders the `company` it is handed and fetches nothing.
const CompanyInformation = ({ company }) => {
  return (
    <InfoCard
      title="Company Info"
      items={[
        ["Company Name", company?.name],
        ["Website", company?.website],
        ["Phone Number", formatPhoneNumber(company?.phoneNumber)],
        ["Country", company?.address?.country],
        ["Company Address", company?.address?.addressLine1],
      ]}
    />
  );
};

export default CompanyInformation;
